import { RefObject, useEffect } from "react"
import { MapRef } from "react-map-gl"
import { useVideoControllerForFlight } from "plugins/Video/controllers/hooks/useController"
import { userLocationSharePlaybackStore } from "./layers/user-locations/userLocationSharePlaybackStore"
import { PlaybackEntityType } from "plugins/shared/playback/state/slice"

export const EntityFollower = ({
    id,
    type,
    mapRef,
    hasCancelledFollow,
}: {
    id: string
    type: PlaybackEntityType
    mapRef: RefObject<MapRef | null>
    hasCancelledFollow: RefObject<boolean>
}) => {
    const controller = useVideoControllerForFlight({ flightId: type === "video" ? id : "" })

    useEffect(() => {
        hasCancelledFollow.current = false
    }, [hasCancelledFollow])
    useEffect(() => {
        const map = mapRef.current
        if (!map) return
        let rafId = 0
        let lastFrameCompletedAt = 0
        const updateMap = (timestamp: number) => {
            if (hasCancelledFollow.current) return
            const duration = timestamp - lastFrameCompletedAt
            lastFrameCompletedAt = timestamp
            const position =
                controller?.getCurrentFrameData() ??
                userLocationSharePlaybackStore.getItem(id)?.current
            if (position) {
                map.easeTo({
                    center: [position.longitude, position.latitude],
                    duration,
                })
            }
            rafId = requestAnimationFrame(updateMap)
        }
        updateMap(0)
        return () => cancelAnimationFrame(rafId)
    }, [controller, hasCancelledFollow, mapRef, id])
    return null
}
